import { render } from "./ClickToCallButton.vue?vue&type=template&id=12905c1a&scoped=true"
import script from "./ClickToCallButton.vue?vue&type=script&lang=js"
export * from "./ClickToCallButton.vue?vue&type=script&lang=js"

import "./ClickToCallButton.vue?vue&type=style&index=0&id=12905c1a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12905c1a"]])

export default __exports__